import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../../constants/layout/store/filterSlice";
import { Table, Accordion, Card } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import CustomDatePicker from "../../../../../components/Custom-Datepicker";
import {
  GetServiceCaller,
  PostFormServiceCaller,
  PostServiceCaller,
} from "../../../../../services/serviceCaller";
import { API_URL } from "../../../../../constants";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import moment from "moment";
import Select from "react-select";
import { toast } from "react-toastify";

const EmployeePayrolls = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const [employeeData, setEmployeeData] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
    const storedData = sessionStorage.getItem("employeeData");
    if (storedData) {
      setEmployeeData(JSON.parse(storedData));
    }
  }, []);

  useEffect(() => {
    dispatch(updateNavbarHeading("Employee Payrolls"));
  }, []);

  const initialFormData = {
    Code: "",
    saluation: "",
    firstname: "",
    middleName: "",
    lastName: "",
    scale: "",
    effectiveFromDate: "",
    isOnPayroll: "",
  };
  const [formData, setFormData] = useState(initialFormData);
  const [empPayrollData, setEmpPayrollData] = useState([]);
  const [payrollType, setPayrollType] = useState();
  const [calculatedPayrollData, setCalculatedPayrollData] = useState([]);
  const [saluationOpt, setSaluationOpt] = useState([]);
  const [scaleOpt, setScaleOpt] = useState([]);
  const [EmpPayrollHistory, setEmpPayrollHistory] = useState([]);
 const [EmpScaleIDDisable, setempScaleIDDisable] = useState('');
  const [editingIndex, setEditingIndex] = useState(null);
  const [selectedScale, setSelectedScale] = useState("");
  
  const handlePayrollCheckboxChange = (e) => {
    const isChecked = e.target.checked ? 1 : 0;
    setUserCheckedOnPayroll(isChecked); // Store user's choice
    setFormData((prev) => ({
      ...prev,
      isOnPayroll: isChecked,
      // Reset scale if unchecking
      // scale: isChecked ? prev.scale : "",
    }));

    // If checking and scale exists, refresh data
    if (isChecked && formData.scale) {
      // fetchEmployeePayrollData(formData.scale);
    }
  };

  // Modified select handler
  const handleScaleSelect = async (selectedOption) => {
    const selectedValue = selectedOption?.value || "";
    setFormData((prev) => ({
      ...prev,
      scale: selectedValue,
    }));

    if (selectedValue) {
      await fetchEmployeePayrollData(selectedValue);
    }
  };
  // const handlePayrollCheckboxChange = (e) => {
  //   setFormData((prev) => ({
  //     ...prev,
  //     isOnPayroll: e.target.checked ? 1 : 0,
  //   }));
  // };
  const [userCheckedOnPayroll, setUserCheckedOnPayroll] = useState(null);

  const fetchEmployeePayrollData = async (
    scaleID = null,
    isInitialCall = true
  ) => {
    try {
      const initialApiUrl = `${API_URL}rujul/employee-payroll/${id}?scaleID=${scaleID || ""
        }`;
      const detailsApiUrl = `${API_URL}rujul/employee-payroll-details/${id}`;

      const apiUrl = isInitialCall ? initialApiUrl : detailsApiUrl;
      let response = await GetServiceCaller(apiUrl);
      if (response?.status === 200) {
        // const EmpHistory = response?.data?.data || [];
        // setEmpPayrollHistory(EmpHistory);
        if (isInitialCall) {
          const EmpHistory = response?.data?.data || [];
          setEmpPayrollHistory(EmpHistory);
        }

        const getPayroll = response?.data?.employeePayroll?.[0] || {};
        setEmpPayrollData(getPayroll);
        // const datePayroll = getPayroll;

        const today = new Date();
        const formattedToday = `${today.getMonth() + 1
          }/${today.getDate()}/${today.getFullYear()}`;
        const firstFromDate = getPayroll?.[0]?.FromDate || formattedToday;
        setFormData((item) => ({
          ...item,
          effectiveFromDate: firstFromDate,
        }));
        const empDetails = response?.data?.contactInformation || [];
        const empScaleID = response?.data?.defaultscale;
        const apiOnPayroll = response?.data?.onpayroll;
        setempScaleIDDisable(empScaleID);
        if (empDetails.length > 0) {
          setFormData((prev) => ({
            ...prev,
            Code: empDetails[0]?.Code || "",
            saluation: empDetails[0]?.Salutation_019 || "",
            firstname: empDetails[0]?.FirstName || "",
            middleName: empDetails[0]?.MiddleName || "",
            lastName: empDetails[0]?.LastName || "",
            // effectiveFromDate: firstFromDate  || "",
            scale: scaleID || prev.scale || empScaleID,
            // Use user's checked state if exists, otherwise use API value
            isOnPayroll:
              userCheckedOnPayroll !== null
                ? userCheckedOnPayroll
                : apiOnPayroll,
          }));
        }

        if (isInitialCall) {
          if ((apiOnPayroll === 1 || userCheckedOnPayroll === 1) && !scaleID) {
            await fetchEmployeePayrollData(null, false);
          } else if (
            empScaleID &&
            empScaleID !== scaleID &&
            userCheckedOnPayroll !== 1
          ) {
            await fetchEmployeePayrollData(empScaleID, false);
          }
        }
      }
    } catch (error) {
      console.error("Error fetching Employee Payroll:", error);
    }
  };

  useEffect(() => {
    fetchEmployeePayrollData();
  }, []);

  const fetchPayrollTypeData = async () => {
    try {
      let response = await GetServiceCaller(`${API_URL}rujul/employee-payroll`);
      if (response?.status === 200) {
        const getPayrolltype = response?.data?.data?.payrollTypeDS;
        setPayrollType(getPayrolltype);
        const saluationOptions = response?.data?.data?.salutions?.map(
          (option) => ({
            label: option.text,
            value: option.value,
          })
        );
        setSaluationOpt(saluationOptions);
        const scaletypeOptions = response?.data?.data?.scale?.map((option) => ({
          label: option.text,
          value: option.value,
        }));
        setScaleOpt(scaletypeOptions);
      } else {
        console.error(
          "Failed to fetch Employee Payroll. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Employee Payroll:", error);
    }
  };
  useEffect(() => {
    fetchPayrollTypeData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleAmountChange = (e, index) => {
    const newAmount = e.target.value ? parseFloat(e.target.value) : parseFloat(0);
    const updatedData = [...empPayrollData];

    // Add a check to make sure the object exists at the index
    if (!updatedData[index]) {
      updatedData[index] = {};
    }

    updatedData[index].Amount = newAmount;
    updatedData[index].AnnualAmount = newAmount * 12;
    updatedData[index].Formula = `${newAmount} `;
    setEmpPayrollData(updatedData);
  };

  const [editingAnnualIndex, setEditingAnnualIndex] = useState(null);

 const handleAnnualAmountChange = (e, index) => {
  const inputValue = e.target.value;
  // Convert to number, default to 0 if empty or invalid
  const newAnnualAmount = inputValue === '' ? null : parseFloat(inputValue) || 0;  
  setEmpPayrollData(prevData => {
    const updatedData = [...prevData];
    updatedData[index] = {
      ...updatedData[index],
      AnnualAmount: newAnnualAmount
    };
    return updatedData;
  });
};

  useEffect(() => {
    if (empPayrollData?.length > 0) {
      const payrollAmounts = {};
      empPayrollData.forEach((row) => {
        payrollAmounts[row.Code] = parseFloat(row.Amount) || 0;
      });

      const updatedData = empPayrollData.map((row) => {
        let formula = row.Formula?.trim(); // Trim to avoid white space issues
        let calculatedValue = row.Amount;

        // ✅ Skip specific formula
        if (formula === "[Basic_DA]*0.6818") {
          console.log(
            `Skipping calculation for ${row.Code} due to fixed formula.`
          );
          return { ...row, Amount: row.Amount }; // Leave value as is
        }

        if (formula && /[\[\]]/.test(formula)) {
          let evaluatedFormula = formula.replace(
            /\[([^\]]+)\]/g,
            (match, p1) => {
              return payrollAmounts[p1] !== undefined ? payrollAmounts[p1] : 0;
            }
          );

          evaluatedFormula = evaluatedFormula
            .replace(/if\s*\((.*?)\)\s*\?/g, "($1) ?")
            .replace(/:\s*\( if\s*\((.*?)\)\s*\?/g, ": ($1) ?")
            .replace(/\)\s*,/g, ") ,");

          try {
            calculatedValue = eval(evaluatedFormula);
            payrollAmounts[row.Code] = calculatedValue;
          } catch (error) {
            console.error(`Formula Error in ${row.Code}:`, error);
            calculatedValue = "Error";
          }
        }

        console.log(
          "Code:",
          row.Code,
          "Total:",
          row.Amount,
          "Annual:",
          row.AnnualAmount
        );

        return { ...row, Amount: calculatedValue };
      });

      setCalculatedPayrollData(updatedData);
    }
  }, [empPayrollData]);

  const groupedData = EmpPayrollHistory.reduce((acc, item) => {
    if (!acc[item.FromDate]) {
      acc[item.FromDate] = [];
    }
    acc[item.FromDate].push(item);
    return acc;
  }, {});

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = {
      OnPayroll: formData.isOnPayroll || 0,
      EffectiveDate:
        moment(formData.effectiveFromDate).format("YYYY-MM-DD") || "",
      records: calculatedPayrollData.map((item) => ({
        ContactID: item.ContactID || null,
        LineNo: item.LineNo || null,
        ScaleID: item.ScaleID || null,
        PayrollID: item.PayrollID || null,
        Formula: item.Formula || "",
        Amount: item.Amount ? Number(item.Amount).toFixed(5) : "0.00000",
        // AnnualAmount: (Number(item.Amount || 0) * 12).toFixed(5),
        AnnualAmount: item.AnnualAmount
          ? Number(item.AnnualAmount).toFixed(5)
          : (Number(item.Amount || 0) * 12).toFixed(5),
      })),
    };
    try {
      const response = await PostFormServiceCaller(
        // `${API_URL}rujul/employee-payro/${id}`,
        `${API_URL}rujul/employee-payroll/${id}`,
        payload,
        "put"
      );

      // Display success message on successful API response
      toast.success("Data submitted successfully!", {
        position: "top-right",
        autoClose: 3000, // Close after 3 seconds
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } catch (error) {
      // Handle errors and display error toast message
      toast.error("Failed to submit data!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });

      console.error("Error:", error);
    }
  };
  const [activeIndex, setActiveIndex] = useState("");
  return (
    <>
      <div className="Container">
        <form id="formOne" className="rounded mt-2 bg-white">
          <div className="container-fluid p-0">
            {/* Tab Section Start */}
            <ul className="nav nav-tabs overflow" id="myTab" role="tablist">
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link active"
                  style={{ color: "#2F2E4B" }}
                  id="emp-payroll-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#emp-payroll"
                  type="button"
                  role="tab"
                  aria-controls="emp-payroll"
                  aria-selected="false"
                >
                  <strong>General & Scale Details</strong>
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  style={{ color: "#2F2E4B" }}
                  id="emp-payroll-history-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#emp-payroll-history"
                  type="button"
                  role="tab"
                  aria-controls="emp-payroll-history"
                  aria-selected="false"
                >
                  <strong>Employee Payroll History</strong>
                </button>
              </li>
            </ul>
            {/* Tab Body Start */}
            <div className="tab-content" id="myTabContent">
              <div
                className="tab-pane fade show active"
                id="emp-payroll"
                role="tabpanel"
                aria-labelledby="emp-payroll-tab"
              >
                <div className="row mt-2">
                  <div>
                    <div className="row mt-2">
                      <div className="col-md-2">
                        <div class="mb-3">
                          <label for="Code" class="form-label">
                            Code
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="Code"
                            onChange={handleChange}
                            value={formData.Code}
                            disabled
                          />
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div class="mb-3">
                          <label for="Salutation" class="form-label">
                            Salutation
                          </label>
                          <Select
                            type="text"
                            // className="form-control"
                            name="saluation"
                            options={[
                              { value: "", label: "Select" },
                              ...saluationOpt,
                            ]}
                            value={saluationOpt.find(
                              (option) => option.value === formData?.saluation
                            )}
                            isDisabled
                          // onChange={(selectedOption, action) => {
                          //   handleSelect(selectedOption, action.name);
                          // }}
                          />
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div class="mb-3">
                          <label for="firstName" class="form-label">
                            First Name
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="firstName"
                            onChange={handleChange}
                            value={formData.firstname}
                            disabled
                          />
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div class="mb-3">
                          <label for="middleName" class="form-label">
                            Middle Name
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="middleName"
                            onChange={handleChange}
                            disabled
                          />
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div class="mb-3">
                          <label for="lastName" class="form-label">
                            Last Name
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="lastName"
                            onChange={handleChange}
                            value={formData.lastName}
                            disabled
                          />
                        </div>
                      </div>
                      <div className="col-md-2 mt-4">
                        <input
                          className="form-check-input me-2"
                          type="checkbox"
                          name="IsGroup"
                          id="flexSwitchCheckChecked"
                          checked={formData?.isOnPayroll}
                          onChange={handlePayrollCheckboxChange}
                        />
                        <label
                          htmlFor="flexSwitchCheckChecked"
                          className="form-label"
                        >
                          On Payroll
                        </label>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-2">
                        <div class="mb-3">
                          <label for="Scale" class="form-label">
                            Scale
                          </label>

                          <Select
                            name="scale"
                            options={[
                              { value: "", label: "Select" },
                              ...scaleOpt,
                            ]}
                            value={
                              scaleOpt.find(
                                (option) => option.value === formData.scale
                              ) || { value: "", label: "Select" }
                            }
                            onChange={handleScaleSelect}
                            // isDisabled={!EmpScaleIDDisable}
                            ////As discussed with fazil sir 
                            isDisabled={true}
                          />
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div class="mb-3">
                          <label for="effectiveFromDate" class="form-label">
                            Effective From Date
                          </label>
                          <CustomDatePicker
                            handleChange={(e) => handleChange(e)}
                            value={formData.effectiveFromDate}
                            name="effectiveFromDate"
                            id="effectiveFromDate"
                            className="form-control"
                            placeholderText="DD-MM-YYYY"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="container-fluid">
                    <h6>
                      <strong>Employee Payroll</strong>
                    </h6>
                    <Table striped bordered hover>
                      <thead id="thcolor" className="text-center">
                        <tr>
                          <th style={{ width: "12.5%" }}>Payroll Code</th>
                          <th style={{ width: "12.5%" }}>Payroll</th>
                          <th style={{ width: "12.5%" }}>Payroll Type</th>
                          <th style={{ width: "12.5%" }}>Formula</th>
                          <th style={{ width: "12.5%" }}>From Date</th>
                          <th style={{ width: "12.5%" }}>To Date</th>
                          <th style={{ width: "12.5%" }}>Total Amount</th>
                          <th style={{ width: "12.5%" }}>Annual Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        {calculatedPayrollData?.length > 0 ? (
                          <>
                            {calculatedPayrollData
                              .sort((a, b) => a.Sequence - b.Sequence)
                              .map((item, index) => {
                                const isFormula =
                                  /\[.*\]/.test(item.Formula) &&
                                  item.Formula !== "[Basic_DA]*0.6818";

                                return (
                                  <tr
                                    key={index}
                                    style={
                                      isFormula ? { fontWeight: "bold" } : {}
                                    }
                                  >
                                    <td>{item.Code || ""}</td>
                                    <td>{item.Payroll || ""}</td>
                                    <td>
                                      {payrollType?.find(
                                        (payroll) =>
                                          payroll.value === item.PayrollType
                                      )?.text || ""}
                                    </td>

                                    <td>
                                      <OverlayTrigger
                                        placement="right"
                                        overlay={
                                          <Tooltip id={`tooltip-${index}`}>
                                            {item.Formula || ""}
                                          </Tooltip>
                                        }
                                      >
                                        <span
                                          className="d-inline-block text-truncate"
                                          style={{ maxWidth: "150px" }}
                                        >
                                          {item.Formula?.replace(
                                            /if\s*\((.*?)\)\s*\?/g,
                                            "($1) ?"
                                          )
                                            .replace(
                                              /:\s*\( if\s*\((.*?)\)\s*\?/g,
                                              ": ($1) ?"
                                            )
                                            .replace(/\)\s*,/g, ") ,")}
                                        </span>
                                      </OverlayTrigger>
                                    </td>

                                    <td className="text-center">
                                      {item.FromDate
                                        ? moment(item.FromDate).format(
                                          "DD-MMM-YYYY"
                                        )
                                        : "-"}
                                    </td>
                                    <td className="text-center">
                                      {item.ToDate
                                        ? moment(item.ToDate).format(
                                          "DD-MMM-YYYY"
                                        )
                                        : "-"}
                                    </td>

                                    {/* <td
                                    className="text-end"
                                    onClick={() => setEditingIndex(index)}
                                    style={{ cursor: "pointer" }}
                                  >
                                    {isFormula ? (
                                      item.Amount
                                    ) : editingIndex === index ? (
                                      <input
                                        type="number"
                                        className="form-control text-end"
                                        value={item.Amount || ""}
                                        onChange={(e) =>
                                          handleAmountChange(e, index)
                                        }
                                        onBlur={() => setEditingIndex(null)}
                                        autoFocus
                                      />
                                    ) : (
                                      item.Amount || 0
                                    )}
                                  </td> */}
                                    <td
                                      className="text-end"
                                      onClick={() => setEditingIndex(index)}
                                      style={{ cursor: "pointer" }}
                                    >
                                      {isFormula ? (
                                        Number(item.Amount || 0).toLocaleString(
                                          "en-IN",
                                          {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                          }
                                        )
                                      ) : editingIndex === index ? (
                                    <input
  type="number"
  min="0"
  className="form-control text-end"
  value={
    item.Amount === null || item.Amount === undefined
      ? ''
      : parseFloat(item.Amount).toString()
  }
  onChange={(e) => handleAmountChange(e, index)}
  onBlur={() => setEditingIndex(null)}
  autoFocus
/>


                                      ) : (
                                        Number(item.Amount || 0).toLocaleString(
                                          "en-IN",
                                          {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                          }
                                        )
                                      )}
                                    </td>
                                    {/* <td
                                    className="text-end"
                                    onClick={() => setEditingAnnualIndex(index)}
                                    style={{ cursor: "pointer" }}
                                  >
                                    {item.Code === "P_TAX_MH_MALE" ? (
                                      "-"
                                    ) : editingAnnualIndex === index ? (
                                      <input
                                        type="number"
                                        className="form-control text-end"
                                        value={item.AnnualAmount || ""}
                                        onChange={(e) =>
                                          handleAnnualAmountChange(e, index)
                                        }
                                        onBlur={() =>
                                          setEditingAnnualIndex(null)
                                        }
                                        autoFocus
                                      />
                                    ) : (
                                      item.AnnualAmount ||
                                      (Number(item.Amount || 0) * 12).toFixed(2)
                                    )}
                                  </td> */}
                                    <td
                                      className="text-end"
                                      onClick={() =>
                                        setEditingAnnualIndex(index)
                                      }
                                      style={{ cursor: "pointer" }}
                                    >
                                      {item.Code === "P_TAX_MH_MALE" ? (
                                        "-"
                                      ) : editingAnnualIndex === index ? (
                              <input
  type="number"
  className="form-control text-end"
  value={
    item.AnnualAmount === null || item.AnnualAmount === undefined
      ? ''
      : parseFloat(item.AnnualAmount).toString()
  }
  onChange={(e) => handleAnnualAmountChange(e, index)}
  onBlur={() => setEditingAnnualIndex(null)}
  autoFocus
/>

                                      ) : (
                                        Number(
                                          item.AnnualAmount ||
                                          Number(item.Amount || 0) * 12
                                        ).toLocaleString("en-IN", {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        })
                                      )}
                                    </td>
                                  </tr>
                                );
                              })}

                            <tr
                              style={{
                                fontWeight: "bold",
                                backgroundColor: "#f8f9fa",
                              }}
                            >
                              <td colSpan="6" className="text-end">
                                Total CTC:
                              </td>
                              <td className="text-end"></td>
                              {/* <td className="text-end">
                              {calculatedPayrollData
                                .reduce((sum, item) => {
                                  if (
                                    item.Code === "P_TAX_MH_MALE" ||
                                    item.Code === "N_SAL" ||
                                    item.Code === "G_SAL"
                                  )
                                    return sum; // Skip P_TAX_MH_MALE
                                  const annualAmount = Number(
                                    item.AnnualAmount ||
                                      Number(item.Amount || 0) * 12
                                  );
                                  return sum + annualAmount;
                                }, 0)
                                .toFixed(2)}
                            </td> */}
                              <td className="text-end">
                                {Number(
                                  calculatedPayrollData.reduce((sum, item) => {
                                    if (
                                      item.Code === "P_TAX_MH_MALE" ||
                                      item.Code === "N_SAL" ||
                                      item.Code === "G_SAL"
                                    )
                                      return sum; // Skip specified codes
                                    const annualAmount = Number(
                                      item.AnnualAmount ||
                                      Number(item.Amount || 0) * 12
                                    );
                                    return sum + annualAmount;
                                  }, 0)
                                ).toLocaleString("en-IN", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                              </td>
                            </tr>
                          </>
                        ) : (
                          <tr>
                            <td colSpan="8" className="text-center">
                              No Data Available
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>
                  <div className="text-end">
                          <button
                                    type="reset"
                                    onClick={() => navigate("/employee-list")}
                                    className="cancel-btn me-2"
                                >
                                    Cancel
                                </button>
                    <button className="custom-btn" onClick={handleSubmit}>
                      Submit
                    </button>
                  </div>
                </div>
              </div>
              <div
                className="tab-pane fade show"
                id="emp-payroll-history"
                role="tabpanel"
                aria-labelledby="emp-payroll-history-tab"
              >
                <div className="row mt-2">
                  <div className="accordion-table">
                    <Table bordered>
                      <thead className="text-center" id="thcolor">
                        <tr>
                          <th style={{ width: "10%" }}>Scale</th>
                          <th style={{ width: "20%" }}>Payroll</th>
                          <th style={{ width: "40%" }}>Formula</th>
                          <th style={{ width: "10%" }}>From Date</th>
                          <th style={{ width: "10%" }}>To Date</th>
                          <th style={{ width: "10%" }}>Total Amount</th>
                          <th style={{ width: "10%" }}>Annual Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        {Object.keys(groupedData).length === 0 ? (
                          <tr>
                            <td colSpan={6} className="text-center">
                              No record found
                            </td>
                          </tr>
                        ) : (
                          Object.entries(groupedData).map(
                            ([fromDate, records], index) => (
                              <tr className="group-header" key={fromDate}>
                                <td colSpan={7}>
                                  <div className="accordion">
                                    <div className="accordion-item" key={index}>
                                      <div
                                        className="accordion-header"
                                        onClick={() =>
                                          setActiveIndex(
                                            activeIndex === index ? null : index
                                          )
                                        }
                                      >
                                        FromDate:{" "}
                                        {moment(fromDate).format("DD-MMM-YYYY")}
                                        <span className="accordion-icon">
                                          {activeIndex === index ? "−" : "+"}
                                        </span>
                                      </div>
                                      {activeIndex === index && (
                                        <div className="accordion-content">
                                          <table className="accordion-table">
                                            <tbody>
                                              {records.map((item, idx) => (
                                                <tr key={idx}>
                                                  <td style={{ width: "10%" }}>
                                                    {item.Scale}
                                                  </td>
                                                  <td style={{ width: "20%" }}>
                                                    {item.Payroll}
                                                  </td>
                                                  <td
                                                    style={{
                                                      width: "40%",
                                                      maxWidth: "300px",
                                                    }}
                                                  >
                                                    <OverlayTrigger
                                                      placement="right"
                                                      overlay={
                                                        <Tooltip>
                                                          {item.Formula || ""}
                                                        </Tooltip>
                                                      }
                                                    >
                                                      <div
                                                        style={{
                                                          whiteSpace: "nowrap",
                                                          overflow: "hidden",
                                                          textOverflow:
                                                            "ellipsis",
                                                        }}
                                                      >
                                                        {item.Formula || ""}
                                                      </div>
                                                    </OverlayTrigger>
                                                  </td>
                                                  <td className="text-center" style={{ width: "10%" }}>
                                                    {item.FromDate
                                                      ? moment(
                                                        item.FromDate
                                                      ).format("DD-MMM-YYYY")
                                                      : ""}
                                                  </td>
                                                  <td className="text-center" style={{ width: "10%" }}>
                                                    {item.ToDate
                                                      ? moment(
                                                        item.ToDate
                                                      ).format("DD-MMM-YYYY")
                                                      : ""}
                                                  </td>
                                                  <td
                                                    className="text-end"
                                                    style={{ width: "10%" }}
                                                  >
                                                    {Number(
                                                      item.Amount
                                                    ).toLocaleString("en-US", {
                                                      minimumFractionDigits: 2,
                                                      maximumFractionDigits: 2,
                                                    })}
                                                  </td>
                                                  <td
                                                    className="text-end"
                                                    style={{ width: "10%" }}
                                                  >
                                                    {Number(item.AnnualAmount || 0).toLocaleString("en-US", {
                                                      minimumFractionDigits: 2,
                                                      maximumFractionDigits: 2,
                                                    })}
                                                  </td>
                                                </tr>
                                              ))}
                                            </tbody>
                                          </table>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            )
                          )
                        )}
                      </tbody>
                    </Table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default EmployeePayrolls;
